import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryForm from './baseQueryForm';

const ecom = createApi({
    reducerPath: 'ecom',
    baseQuery: baseQueryForm,
    endpoints: (builder) => ({
        orders: builder.mutation({
            query: (param) => ({
                url: 'ecom/orders',
                method: 'POST',
                body: param,
            }),
        }),
    }),
});
export const { useOrdersMutation } = ecom;
export default ecom;